<script setup lang="ts">
import RouterViewTransition from '@/core/components/RouterViewTransition.vue'
import LanguageSwitcher from '@/core/components/LanguageSwitcher.vue'

document.body.className = 'simakatra'
</script>

<template>
  <LanguageSwitcher class="top-right z-10">
    <template #th><img src="/images/lang-th.png" /></template>
    <template #en><img src="/images/lang-en.png" /></template>
  </LanguageSwitcher>
  <RouterViewTransition />
</template>

<style>
body.simakatra {
  background: black;
}

body.simakatra #app {
  width: 1920px;
  height: 1080px;
  margin: 0;
  padding: 0;
  color: #d7a66a;
  background-color: #4c5b5e;
  background-image: url(/images/simakatra/bg-main.jpg);
  /* background-image: url(@/assets/images/template-main-th.png); */
  /* background-image: url(@/assets/images/template-main-en.png); */
  /* background-image: url(@/assets/images/template-index-th.png); */
  /* background-image: url(@/assets/images/template-index-en.png); */
  overflow: hidden;
}
</style>
